import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customers" }

import CustomersPagination from "@/components/smstemplate/CustomersPagination.vue";
import CustomersList from "@/components/smstemplate/CustomersList.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Clients',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomersPagination),
    _createVNode(CustomersList)
  ]))
}
}

})